import { render, staticRenderFns } from "./promocode-table.vue?vue&type=template&id=066c2b50"
import script from "./promocode-table.vue?vue&type=script&lang=js"
export * from "./promocode-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports